import { render, staticRenderFns } from "./newsdetails.vue?vue&type=template&id=ba121fd0&scoped=true&"
import script from "./newsdetails.vue?vue&type=script&lang=js&"
export * from "./newsdetails.vue?vue&type=script&lang=js&"
import style0 from "./newsdetails.vue?vue&type=style&index=0&id=ba121fd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba121fd0",
  null
  
)

export default component.exports